// Generated by purs version 0.13.8
"use strict";
var $foreign = require("./foreign.js");
var Control_Promise = require("../Control.Promise/index.js");
var getString = Control_Promise.toAffE($foreign["_getString"]);
module.exports = {
    getString: getString,
    setString: $foreign.setString
};
